<template lang="pug">
	section
		NothingFound(v-if="speakers.data.length===0")

		b-table.no-header.mb-0.table-outline(responsive='sm' hover :items='speakersList' head-variant='light' v-else)

			template(v-slot:cell(speaker)="item")
				speakerCard(:_speaker="item")

		b-pagination.mt-4(v-model="currentPage" :total-rows="speakers.data.length" :per-page="perPage" align="center"  v-if="speakers.data.length>perPage")
</template>
<script>
	import {mapActions, mapGetters, mapState} from "vuex";
	import speakerCard from '../cards/speakerCard'


	export default {
		name: 'Speakers',
		components: {speakerCard},
		data: () => ({
			perPage: 5,
			currentPage: 1,
		}),
		computed: {
			...mapState(['event']),
			...mapState({
				speakers: state=>state.event.speakers,
			}),
			speakersList() { return this._paginatedSpeakers.reduce( (acc,item) => [...acc, {speaker:item}],[]) },
			_paginatedSpeakers(){ return this.paginate(this.speakers.data,{perPage:this.perPage,currentPage:this.currentPage}) },
		},
		methods:{
			...mapActions('event/nested/speakers',['getEventSpeakers']),
			...mapGetters(['changeTabPageEvent']),

			paginate(arr,{perPage,currentPage}){ return arr.slice(perPage*(currentPage-1), perPage*(currentPage-1)+perPage) },
		},
		beforeMount(){
			this.$store.dispatch('getEventSpeakers',{ id:this.event.data.id })
		}
	}
</script>


<style>
	.no-header table {
		margin-bottom: 0;
	}
	.no-header thead {
		display: none!important;
	}
	.no-header tbody tr:first-of-type td {
		border-top: none;
	}
</style>
